import axios from 'axios';
import { req } from '../../@api/request';

export interface ISearchList {
  iidx: number;
  type: 'a' | 'p' | 'e';
  caseno: string;
  court: string;
  iaddr: string;
  unitno: string;
  lat: number;
  lng: number;
  group_category: string;
  status: string;
}

export default class AuctionListService {
  static controller: any;

  static List = async (
    type: string,
    region: string,
    mibidno: number,
    maxbidno: number,
    minlandArea: number,
    maxlandArea: number,
    residentialCategory: string,
    commicialCategory: string,
    landCategory: string,
    minconstructArea: number,
    maxconstructArea: number,
    minappraisedValue: number,
    maxappraisedValue: number,
    minBidPrice: number,
    maxBidPrice: number,
    specificRight: string,
    minroe: number,
    maxroe: number,
    search: string,
    sort: string,
    limit: number,
    offset: number,
    newItem: string,
    court?: string,
    unitno?: string,
    specialItem?: string,
    type2?: string,
  ) => {
    if (AuctionListService.controller) {
      AuctionListService.controller.cancel('Component unmounted');
    }

    const source = axios.CancelToken.source();

    // 새로운 요청을 위한 Abort AuctionListService.Controller 생성
    AuctionListService.controller = source;
    const result = await req.get2(
      `/loan/list?type=${type}&search=${search}&region=${region}&minbidno=${mibidno}&maxbidno=${maxbidno}&minlandArea=${minlandArea}&maxlandArea=${maxlandArea}&residentialCategory=${residentialCategory}` +
        `&commicialCategory=${commicialCategory}&landCategory=${landCategory}&minconstructArea=${minconstructArea}&maxconstructArea=${maxconstructArea}&minappraisedValue=${minappraisedValue}&maxappraisedValue=${maxappraisedValue}` +
        `&minBidPrice=${minBidPrice}&maxBidPrice=${maxBidPrice}&specificRight=${specificRight}&minroe=${minroe}&maxroe=${maxroe}&sort=${sort}&limit=${limit}&offset=${offset}&court=${court}&unitno=${unitno}&newItem=${newItem}` +
        `&specialItem=${specialItem}&type2=${
          type2 === '' ? type2 : type2 === '경매' ? 'a' : 'p'
        }`,
      { cancelToken: AuctionListService.controller.token },
    );

    return result.data;
  };

  static propertyList = async (
    search: string | undefined,
    limit: number,
    offset: number,
  ) => {
    const result = await req.get(
      `/property/list2?search=${search}&limit=${limit}&offset=${offset}`,
    );
    return result.data;
  };

  static search = async (search: string, year?: string) => {
    if (AuctionListService.controller) {
      AuctionListService.controller.cancel('Component unmounted');
    }
    const source = axios.CancelToken.source();
    AuctionListService.controller = source;
    const result = await req.get2(`/search?search=${search}`, {
      cancelToken: AuctionListService.controller.token,
    });

    return result.data;
  };

  static List2 = async () => {
    const result = await req.get(
      `/loan/list?type=&search=&region=&minbidno=&maxbidno=&minlandArea=&maxlandArea=&residentialCategory=&commicialCategory=&landCategory=&minconstructArea=&maxconstructArea=&minappraisedValue=&maxappraisedValue=&minBidPrice=&maxBidPrice=&specificRight=&minroe=&maxroe=&sort=DA&limit=6&offset=&court=&unitno=`,
    );
    return result.data;
  };
}
